import { render, staticRenderFns } from "./AccountConfigCard.vue?vue&type=template&id=024f8e49&"
import script from "./AccountConfigCard.vue?vue&type=script&lang=ts&"
export * from "./AccountConfigCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports